module.exports = __webpack_public_path__ + "static/media/loading_light.c69ca6fb.gif";